import './menuButton.scss';

const MenuButton = ({ name, onClickAction, isSelected }) => {
    return (
        <article onClick={() => onClickAction()} className="a-menuButton">
            <p
                className={`a-menuButton__name${
                    isSelected ? '__selected' : ''
                }`}
            >
                {name}
            </p>
            <i
                className={`icon-angle-right ${
                    isSelected ? 'icon__selected' : ''
                }`}
                title="flecha-a-la-derecha"
            />
        </article>
    );
};

export default MenuButton;
